var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 16,
    fill: "#f2f2f2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 90a20 20 0 1 0-0.1 0z",
    fill: "#d0d0d0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 152c4-20 24-36 50-36s46 16 50 36",
    stroke: "#d0d0d0",
    strokeWidth: 10,
    strokeLinecap: "round",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120 40 160 80",
    stroke: "#d0d0d0",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160 40 120 80",
    stroke: "#d0d0d0",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoPlaceholder);
export default __webpack_public_path__ + "static/media/photo-placeholder.d4f82354b4c2487f872c70f248eb88e0.svg";
export { ForwardRef as ReactComponent };